import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Calendar, User, ArrowRight, Tag, Clock } from 'lucide-react';
import { blogPosts } from '../data/blogPosts';
import { useLanguage } from '../contexts/LanguageContext';
import '../styles/Blog.css';

const Blog = () => {
  const { t } = useLanguage();
  const [isVisible, setIsVisible] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState('All');

  useEffect(() => {
    setIsVisible(true);
    window.scrollTo(0, 0);
  }, []);

  const categories = ['All', ...Array.from(new Set(blogPosts.map((p) => p.category)))];

  const filteredPosts = selectedCategory === 'All'
    ? blogPosts
    : blogPosts.filter((post) => post.category === selectedCategory);

  return (
    <div className="blog-page">
      {/* Page Header */}
      <section className="page-hero">
        <div className="page-hero-overlay"></div>
        <div className="container">
          <div className={`page-hero-content ${isVisible ? 'animated fadeIn' : 'animated'}`}>
            <h1 className="display-large">{t('blog.hero')}</h1>
            <p className="body-large">{t('blog.heroSub')}</p>
          </div>
        </div>
      </section>

      {/* Category Filter */}
      <section className="blog-filter-section">
        <div className="container">
          <div className="blog-filter">
            {categories.map((category) => (
              <button
                key={category}
                className={`filter-btn ${selectedCategory === category ? 'active' : ''}`}
                onClick={() => setSelectedCategory(category)}
                data-testid={`blog-filter-${category.toLowerCase().replace(/\s+/g, '-')}`}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Blog Posts Grid */}
      <section className="blog-posts-section">
        <div className="container">
          <div className="blog-posts-grid">
            {filteredPosts.map((post, index) => (
              <article
                key={post.slug}
                className={`blog-post-card ${isVisible ? 'animated fadeIn' : 'animated'}`}
                style={{ transitionDelay: `${index * 50}ms` }}
                data-testid={`blog-card-${post.slug}`}
              >
                <Link to={`/blog/${post.slug}`} className="blog-post-image">
                  <img src={post.image} alt={post.title} />
                  <span className="blog-category-badge">
                    <Tag size={14} />
                    {post.category}
                  </span>
                </Link>
                <div className="blog-post-content">
                  <div className="blog-post-meta">
                    <span className="meta-item"><Calendar size={16} />{new Date(post.date).toLocaleDateString()}</span>
                    <span className="meta-item"><User size={16} />{post.author}</span>
                    <span className="read-time"><Clock size={14} /> {post.readTime}</span>
                  </div>
                  <h3 className="heading-3 blog-post-title">
                    <Link to={`/blog/${post.slug}`}>{post.title}</Link>
                  </h3>
                  <p className="body-medium blog-post-excerpt">{post.excerpt}</p>
                  <Link to={`/blog/${post.slug}`} className="blog-read-more" data-testid={`blog-read-more-${post.slug}`}>
                    {t('blog.readMore')} <ArrowRight size={18} />
                  </Link>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Blog;
